import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useRefreshKlarnaBanners } from 'lib/hooks'
import { convertDollarPriceToCents } from 'lib/money'
import {
  PAY_IN_4_MIN,
  PAY_IN_4_MAX,
  FINANCING_MIN,
  FINANCING_MAX,
} from 'shared/constants'
import { AfterpayBadge, KlarnaBadge } from './deferred-payment-methods'

export const UnqualifiedMessage = ({ className }) => (
  <div className={classNames('flex align-center wrap', className)}>
    <span className="h7 mrs">
      Pay in 4 {PAY_IN_4_MIN > 1 ? `on orders $${PAY_IN_4_MIN}+` : 'available'}{' '}
      with
    </span>
    <AfterpayBadge />
    <span className="h7 mhs">or</span>
    <KlarnaBadge price={0} />
  </div>
)

UnqualifiedMessage.propTypes = {
  className: PropTypes.string,
}

UnqualifiedMessage.defaultProps = {
  className: '',
}

export const PayIn4Message = ({ className, price }) => (
  <div className={classNames('flex align-center wrap', className)}>
    <span className="mrs h7">
      4 payments of ${(Math.floor((price / 4) * 100) / 100).toFixed(2)} with
    </span>
    <KlarnaBadge price={price} />
    <span className="h7 mhs">or</span>
    <AfterpayBadge />
  </div>
)

PayIn4Message.propTypes = {
  className: PropTypes.string,
  price: PropTypes.number,
}

PayIn4Message.defaultProps = {
  className: '',
  price: 0,
}

export const klarnaTemplates = {
  WHITE_BG: 'credit-promotion-auto-size',
  GRAY_BG: 'custom-type0',
}

export const FinancingMessage = ({ className, price, bgColor }) => {
  useRefreshKlarnaBanners(price)

  return (
    <div className={className}>
      <klarna-placement
        data-key={
          bgColor === 'gray'
            ? klarnaTemplates.GRAY_BG
            : klarnaTemplates.WHITE_BG
        }
        data-locale="en-US"
        data-purchase-amount={convertDollarPriceToCents(price)}
      />
    </div>
  )
}

FinancingMessage.propTypes = {
  bgColor: PropTypes.string,
  className: PropTypes.string,
  price: PropTypes.number.isRequired,
}

FinancingMessage.defaultProps = {
  bgColor: 'white',
  className: '',
}

const DeferredPaymentMessage = ({
  className,
  isElectronicGiftCard,
  price,
  bgColor,
}) => {
  if (isElectronicGiftCard || (price > 0 && price < PAY_IN_4_MIN)) {
    // Currently unused until PAY_IN_4_MIN is raised above $0.01
    return <UnqualifiedMessage className={className} />
  }
  if (PAY_IN_4_MIN <= price && price <= PAY_IN_4_MAX) {
    // $0.01-$1999.99
    return <PayIn4Message className={className} price={price} />
  }
  if (FINANCING_MIN <= price && price <= FINANCING_MAX) {
    // $2000-$9999.99
    return (
      <FinancingMessage className={className} price={price} bgColor={bgColor} />
    )
  }
  return null
}

DeferredPaymentMessage.propTypes = {
  bgColor: PropTypes.string,
  className: PropTypes.string,
  isElectronicGiftCard: PropTypes.bool,
  price: PropTypes.number,
}

DeferredPaymentMessage.defaultProps = {
  bgColor: '',
  className: '',
  isElectronicGiftCard: false,
  price: 0,
}

export default DeferredPaymentMessage
